module.exports = __webpack_public_path__ + "static/media/login-image.4952fe1f.png";